import React from 'react';

import {type ActionPayload} from './file-tagging-provider';

const emptyContextFunction = () => console.warn('File tagging API invoked before initialised');
export interface FileTaggingContextProps {
    addFile: (payload: ActionPayload<'AddFile'>) => void;
    persistFile: (payload: ActionPayload<'PersistFile'>) => void;
    selectNextFile: (payload: ActionPayload<'SelectNextFile'>) => void;
    selectPrevFile: (payload: ActionPayload<'SelectPreviousFile'>) => void;
    discardFile: (payload: ActionPayload<'DiscardFile'>) => void;
    tagChild: (payload: ActionPayload<'TagChild'>) => void;
    untagChild: (payload: ActionPayload<'UntagChild'>) => void;
    confirmWithoutChildren: (payload: ActionPayload<'ConfirmWithoutChildren'>) => void;
    changeFilter: (payload: ActionPayload<'ChangeFilter'>) => void;
    initTaggedChildren: (payload: ActionPayload<'InitTaggedChildren'>) => void;
}

export const FileTaggingContext = React.createContext<FileTaggingContextProps>({
    addFile: emptyContextFunction,
    persistFile: emptyContextFunction,
    selectNextFile: emptyContextFunction,
    selectPrevFile: emptyContextFunction,
    discardFile: emptyContextFunction,
    tagChild: emptyContextFunction,
    untagChild: emptyContextFunction,
    confirmWithoutChildren: emptyContextFunction,
    changeFilter: emptyContextFunction,
    initTaggedChildren: emptyContextFunction,
});
